
import { useFormContext } from 'react-hook-form'
import { Input } from '@/components/ui/input'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'



const DealNameField = () => {
    const useFormReturn = useFormContext();
    const { control } = useFormReturn;

    return (
        <FormField
            control={control}
            name="name"
            render={({ field }) => (
                <FormItem>
                    <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
                        Deal Name <span className="text-accent-red">*</span>
                    </FormLabel>
                    <FormControl>
                        <Input
                            placeholder="Enter deal name"
                            {...field}
                            className="h-10 rounded-xl border-white/[0.06] bg-white/[0.02] px-3 text-[12.5px] text-slate-200 placeholder:text-slate-500 focus:border-brand-500/40 focus-visible:ring-0 focus-visible:ring-offset-0"
                        />
                    </FormControl>
                    <FormMessage className="text-[10.5px] text-accent-red" />
                </FormItem>
            )}
        />
    )
}

export default DealNameField
